@if (service.visible()) {
  <div
    class="download-toast"
    aria-live="polite"
    [attr.aria-label]="service.title()">
    <div class="download-toast__header">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="24"
        aria-hidden="true" />
      <h5 class="download-toast__title">{{ service.title() }}</h5>
    </div>
    <div
      class="download-toast__description"
      [innerHTML]="service.description()"></div>
  </div>
}
